{
  "name": "rivemoderne",
  "version": "0.1.17",
  "private": true,
  "scripts": {
    "generate-build-meta": "node scripts/generate-build-meta.js",
    "build": "npm run generate-build-meta && npx esbuild frontend/main.jsx --bundle --minify --sourcemap --outfile=frontend/dist/app.bundle.js --loader:.js=jsx --loader:.jsx=jsx",
    "start": "node api/server.js",
    "dev": "concurrently \"node api/server.js\" \"npx serve frontend -p 3000\"",
    "test": "node scripts/api-check.js"
  },
  "dependencies": {
    "axios": "^1.14.0",
    "bcryptjs": "^2.4.3",
    "better-sqlite3": "^9.4.3",
    "concurrently": "^8.2.0",
    "cors": "^2.8.5",
    "dotenv": "^16.4.5",
    "esbuild": "^0.19.4",
    "express": "^4.18.3",
    "express-rate-limit": "^7.4.1",
    "helmet": "^8.0.0",
    "jsonwebtoken": "^9.0.2",
    "moment": "^2.30.1",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-responsive-carousel": "^3.2.23",
    "serve": "^14.2.0",
    "stripe": "^22.0.0",
    "uuid": "^9.0.1",
    "winston": "^3.19.0",
    "winston-daily-rotate-file": "^5.0.0"
  }
}
